import { request } from "@client/lib/request";
import { type Api, type HttpApiResponse as ApiResponse, type HttpApiResponse, type InitResponseData } from "@client/types/Api";

export type InitArgs = Api.BasePageArgs & {
  path: string;
};
export type InitResponse = ApiResponse<InitResponseData>;

export default {
  loadPage: async ({
    baseUrl,
    trackingParameters,
    ...args
  }: Api.LoadPageRequest): Promise<HttpApiResponse<Api.LoadPageResponse>> => {
    return request({ method: "GET", url: `${baseUrl}/app/page`, query: { ...args, ...trackingParameters } });
  }
};
